import { dataTransferWrap } from '../dataTransferService'
import { ModulesMap } from '@/config/data/modulesMaps'
import dtConfig from '@/config/data-transfer'

function createCompany(body) {
	return dataTransferWrap(ModulesMap.COMPANY, dtConfig[ModulesMap.COMPANY].createCompany, body)
}

function getCompanyProfile(payload) {
	return dataTransferWrap(ModulesMap.COMPANY, dtConfig[ModulesMap.COMPANY].getCompanyProfile, payload)
}

function updateCompanyProfile(companyId, body) {
	return dataTransferWrap(ModulesMap.COMPANY, dtConfig[ModulesMap.COMPANY].updateCompanyProfile, {
		urlParams: {
			companyId: companyId,
		},
		...body,
	})
}

function getUserCompanyPermission(payload) {
	return dataTransferWrap(
		ModulesMap.COMPANY,
		dtConfig[ModulesMap.COMPANY].getUserCompanyPermission,
		payload
	)
}

export default {
	createCompany,
	getCompanyProfile,
	updateCompanyProfile,
	getUserCompanyPermission,
}
